import { generatePath } from "react-router-dom";
import { takeLatest, put, call, select } from "redux-saga/effects";
import BackendClient from "api/backend-client";
import { RecipeScalingApiMethods } from "api/api-methods";
import { waitForLogin } from "../auth/auth.saga";
import { loadLicensesListSaga } from "store/licensing/licensing.saga";
import { cellModelImportFromFileIdFailure, cellModelImportFromFileIdSuccessful, CellModelListActionType, loadCellModelListFailure, loadCellModelListSuccessful, parseCellModelFileId, parseCellModelFileIdFailure, parseCellModelFileIdSuccessful, uploadCellModelFailure, uploadCellModelSuccessful, } from "./cell-model-list.actions";
import { setCurrentRequestTemplate, setServerError, } from "store/knowledge-base-item/knowledge-base-item.actions";
import RoutePaths from "routes/route-paths";
import { RequestTemplate } from "store/knowledge-base-item/knowledge-base-item.types";
import { cellModelImportFromFileIdSelector } from "./cell-model-list.selectors";
import { GlobalEntityType } from "shared/types";
import { apiErrorHandler } from "store/global/global.saga";
import { navigate } from "shared/navigation";
export function* loadCellModelsSaga() {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const data = yield call([backendClient, RecipeScalingApiMethods.GetCellModelsList]) ||
            [];
        yield put(loadCellModelListSuccessful(data));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "cell models load failed");
        yield put(loadCellModelListFailure());
    }
}
function* importUploadCellModelSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_UPLOAD));
        navigate(RoutePaths.ImportCellModel, {
            fileName: payload.name,
            entity: GlobalEntityType.CellModel,
        });
        const formData = new FormData();
        formData.append("file", payload, payload.name);
        const importFileId = yield call([backendClient, RecipeScalingApiMethods.CellModelUpload], formData);
        yield put(uploadCellModelSuccessful(importFileId));
        yield put(parseCellModelFileId(importFileId));
    }
    catch (e) {
        yield call(apiErrorHandler, e, "upload cell model failed");
        yield put(uploadCellModelFailure());
    }
}
function* parseCellModelFileIdSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_FILE_PARSE));
        const { content, errors } = yield call([backendClient, RecipeScalingApiMethods.CellModelParseFile], payload);
        yield put(parseCellModelFileIdSuccessful(content));
        if (errors) {
            yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_FILE));
            yield put(setServerError({
                error: {
                    status: 400,
                    data: { errors: errors.errors },
                },
            }));
        }
    }
    catch (e) {
        yield call(apiErrorHandler, e, "parse uploaded cell model failed");
        yield put(parseCellModelFileIdFailure());
    }
}
function* cellModelImportFromFileIdSaga({ payload }) {
    try {
        yield call(waitForLogin);
        const backendClient = BackendClient.getInstance();
        const importFileId = yield select(cellModelImportFromFileIdSelector);
        yield put(setCurrentRequestTemplate(RequestTemplate.IMPORT_FILE));
        const cellModelId = yield call([backendClient, RecipeScalingApiMethods.CellModelImportFromFileId], importFileId, payload);
        history.replace(generatePath(RoutePaths.EditCellModel, { id: cellModelId }));
        yield call(loadLicensesListSaga);
        yield put(cellModelImportFromFileIdSuccessful());
    }
    catch (e) {
        yield call(apiErrorHandler, e, "import cell model  failed");
        yield put(cellModelImportFromFileIdFailure());
    }
}
export default function* cellModelListSaga() {
    yield takeLatest(CellModelListActionType.LOAD_LIST, loadCellModelsSaga);
    yield takeLatest(CellModelListActionType.UPLOAD, importUploadCellModelSaga);
    yield takeLatest(CellModelListActionType.PARSE_FILE_ID, parseCellModelFileIdSaga);
    yield takeLatest(CellModelListActionType.IMPORT_FROM_FILE_ID, cellModelImportFromFileIdSaga);
}
